export default __webpack_public_path__ + "assets/5b72e4a6172ce23f75e4f88b3576df06.png";